import ContentfulSubPage from './ContentfulSubPage'

export default ContentfulSubPage
